import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CheckIcon, InfoCircleIcon, Colors } from '@notino/react-styleguide';

import { wishlistMessages } from '../messages';

import { LinkInput, Message } from './styled';

interface IWishlistLinkProps {
  hostUrl: string;
  anonymousId: string;
  isCopySuccessful: boolean;
}

export const WishlistLink: React.FC<IWishlistLinkProps> = ({
  hostUrl,
  anonymousId,
  isCopySuccessful,
}) => (
  <>
    <LinkInput
      type="text"
      id="wishlist-link"
      readOnly={true}
      value={`${hostUrl}/wishlist?id=${anonymousId}`}
    />
    {isCopySuccessful ? (
      <Message color={Colors.success}>
        <CheckIcon height="18" color={Colors.success} />{' '}
        <FormattedMessage {...wishlistMessages.clipboard} />
      </Message>
    ) : (
      <Message color={Colors.alert}>
        <InfoCircleIcon height="12" color={Colors.alert} />{' '}
        <FormattedMessage {...wishlistMessages.clipboardFail} />
      </Message>
    )}
  </>
);
